import { Component, inject } from '@angular/core';
import { LayoutService } from '../../../core/services/layout.service';
import { MainMenuComponent } from '../main-menu/main-menu.component';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { ButtonModule } from 'primeng/button';

@Component({
  standalone: true,
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  imports: [MainMenuComponent, RouterLink, ButtonModule],
})
export class TopbarComponent {
  layoutService = inject(LayoutService);
  authService = inject(AuthService);
}
